export const isStickyInViewMode = (tableElement: HTMLElement | null) => {
	return Boolean(tableElement?.getAttribute('mode') === 'stick');
};

export const isStickyInEditMode = (tableElement: HTMLElement | null) => {
	return Boolean(tableElement?.classList.contains('pm-table-sticky'));
};

export const getIsSticky = (tableElement: HTMLElement | null, isEditor: boolean | undefined) =>
	isEditor ? isStickyInEditMode(tableElement) : isStickyInViewMode(tableElement);
